import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "reactstrap";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Filter } from "lucide-react";
import { setPageData } from "store/actions";
import { useDispatch, useSelector } from "react-redux";

const SearchResults = () => {
  const location = useLocation();
  const searchType = location.state?.searchType
  const inputContains = location.state?.inputContains
  const exactSearchInput = location.state?.exactSearch 
  const excludeSearchInput = location.state?.excludedSearch
  const dispatch = useDispatch();
  const { first, rows,totalRecords } = useSelector((state) => state.calendar.pagination);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    description: { value: null, matchMode: FilterMatchMode.CONTAINS },
    updated_at: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    first_name:{value:null,matchMode:FilterMatchMode.CONTAINS},
    last_name:{value:null,matchMode:FilterMatchMode.CONTAINS},
    middle_name:{value:null,matchMode:FilterMatchMode.CONTAINS},
    email:{value:null,matchMode:FilterMatchMode.CONTAINS},
    resume:{value:null,matchMode:FilterMatchMode.CONTAINS},
    current_company:{value:null,matchMode:FilterMatchMode.CONTAINS},
    mobile_phone:{value:null, matchMode:FilterMatchMode.CONTAINS},
    created_by_name:{value:null,matchMode:FilterMatchMode.CONTAINS},
    employee_type:{value:null,matchMode:FilterMatchMode.CONTAINS},
    total_experience:{value:null,matchMode:FilterMatchMode.CONTAINS},
    city_name:{value:null,matchMode:FilterMatchMode.CONTAINS},
    status:{value:null,matchMode:FilterMatchMode.CONTAINS},
    relocation:{value:null,matchMode:FilterMatchMode.CONTAINS},
    categories:{value:null,matchMode:FilterMatchMode.CONTAINS},
    groups:{value:null,matchMode:FilterMatchMode.CONTAINS},
    primary_skills:{value:null,matchMode:FilterMatchMode.CONTAINS},
    secondary_skills:{value:null,matchMode:FilterMatchMode.CONTAINS},
    other_skills:{value:null,matchMode:FilterMatchMode.CONTAINS},
    created_at:{value:null,matchMode:FilterMatchMode.CONTAINS},
  });
  const [tableData, setTableData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({ rows: 10, first: 0 });


  const getDisplayHeading = (searchType) => {
  const headingMap = {
    resume: "Resume",
    job: "Job Details",
    primary_skills: "Primary Skills",
    secondary_skills: "Secondary Skills",
    notes: "Notes",
  };
  return headingMap[searchType] || searchType.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase());
};



  const fetchSearchResults = async (page) => {
    try {
      setLoading(true);
      const response = await axios.post(`/api/v1/search/?page=${page}`, {
        keyword_search: searchType,
        match: {
          icontains: inputContains || "",
          exclude: excludeSearchInput || "",
          exact: exactSearchInput || "",
        },
      });
      const apiData = response?.data?.results || [];
      dispatch(setPageData({
        first: (page - 1) * rows,
        rows: rows,
        totalRecords: response?.data?.count || 0,
      }));
      const transformedData = apiData.map((item) => ({
        id: item.candidate_id,
        job_title: item.job_title,
        first_name: item.first_name,
        middle_name: item.middle_name,
        last_name: item.last_name,
        email: item.email,
        updated_at: item.updated_at ? item.updated_at.substring(0, 10) : null,
        resume: item.resume || 'N/A',
        current_company: item.current_company,
        mobile_phone: item?.mobile_phone,
        created_by_name: item?.created_by_name,
        total_experience: item.total_experience,
        city_name: item.city_name,
        status: item.status,
        relocation: item.relocation,
        categories: item.category_name || 'N/A',
        groups: item.groups_name || 'N/A',
        primary_skills: item.primary_skill_names || 'N/A',
        secondary_skills: item.secondary_skill_names || 'N/A',
        other_skills: item.other_skill_names || 'N/A',
        created_at: item.created_at ? item.created_at.substring(0, 10) : null,
        availability_date: item.availability_date,
      }));
      setTableData(transformedData);
    } catch (error) {
      console.error("Error fetching search results:", error.message);
    } finally {
      setLoading(false);
    }
  };
//   const fetchSearchResults = async (page) => {
//   try {
//     setLoading(true); // Set loading state to true before the API call
//     const response = await axios.post(`http://66.206.31.78:8000/api/v1/search/?page=${page}`, {
//       keyword_search: searchType,
//       match: {
//         icontains: inputContains || "", // Ensure empty string if undefined
//         exclude: excludeSearchInput || "", // Explicitly include exclude parameter
//         exact: exactSearchInput || "", // Ensure empty string if undefined
//       },
//     });
//     const apiData = response?.data?.results || [];
//     dispatch(setPageData({
//       first: (page - 1) * rows,
//       rows: rows,
//       totalRecords: response?.data?.count || 0,
//     }));
//     // Transform API data to match DataTable structure
//     const transformedData = apiData.map((item, index) => ({
//       id: item.candidate_id,
//       job_title: item.job_title,
//       first_name: item.first_name,
//       middle_name: item.middle_name,
//       last_name: item.last_name,
//       email: item.email,
//       updated_at: item.updated_at ? item.updated_at.substring(0, 10) : null,
//       resume: item.resume,
//       current_company: item.current_company,
//       mobile_phone: item?.mobile_phone,
//       created_by_name: item?.created_by_name,
//       total_experience: item.total_experience,
//       city_name: item.city_name,
//       status: item.status,
//       relocation: item.relocation,
//       categories: item.categories,
//       groups: item.groups,
//       primary_skills: item.primary_skills,
//       created_at: item.created_at ? item.created_at.substring(0, 10) : null,
//       availability_date: item.availability_date,
//     }));
//     setTableData(transformedData);
//   } catch (error) {
//     console.error("Error fetching search results:", error.message);
//   } finally {
//     setLoading(false); // Reset loading state after the API call
//   }
// };



 useEffect(() => {
    const page = Math.floor(first / rows) + 1;
    fetchSearchResults(page);
  }, [searchType, inputContains, exactSearchInput, excludeSearchInput, first, rows]);


  const onPage = (e) => {
    const newPage = Math.floor(e.first/e.rows) + 1
            dispatch(setPageData({
                first:e.first,
                rows:e.rows,
                totalRecords
            }))
            fetchSearchResults(newPage,e.rows)
  };

  const dt = useRef(null);

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  // const handleClearSearch = () => {
  //   setFilters({
  //     global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  //     job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
  //     description: { value: null, matchMode: FilterMatchMode.CONTAINS },
  //     updated_at: { value: null, matchMode: FilterMatchMode.DATE_IS },
  //   });
  // };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <div className="page-title-box mb-0">
            <Row className="align-items-center pt-3 pb-3 breadcrumb-card">
              <Col md={6} lg={6} className="d-flex align-items-center">
                <h3>{getDisplayHeading(searchType)}</h3>
                {selectedTableData.length > 0 && (
                  <>
                    <button
                      type="button"
                      className="btn btn-secondary import-res-btn ms-1 mainbtn me-1"
                    >
                      <i className="fa-regular fa-user me-1"></i>
                      {selectedTableData.length} selected
                    </button>
                    <div className="action-icons me-2">
                      <button
                        type="button"
                        className="btn btn-secondary import-res-btn ms-1 mainbtn mb-1"
                        onClick={() => exportCSV(true)}
                      >
                        <i className="pi pi-download"></i>
                      </button>
                      {/* <button
                        type="button"
                        className="btn btn-secondary import-res-btn ms-1 mainbtn mb-1"
                      >
                        <i className="pi pi-trash"></i>
                      </button> */}
                    </div>
                  </>
                )}
                
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <section className="job-datatable-section">
                  <div className="card1 mt-3 mb-4 datatable-check">
                    <DataTable
                      ref={dt}
                      value={tableData}
                      tableStyle={{
                        minWidth: "50rem",
                        borderRadius: "8px",
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                      }}
                      rows={rows}
                      first={first}
                      totalRecords={totalRecords}
                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} to {last} of {totalRecords}"
                      onPage={onPage}
                      dataKey="id"
                      loading={loading}
                      scrollable
                      emptyMessage="No records found."
                      selection={selectedTableData}
                      onSelectionChange={(e) => setSelectedTableData(e.value)}
                      filters={filters}
                      filterDisplay="row"
                      reorderableRows
                      resizableColumns
                      columnResizeMode="expand"
                    >
                      <Column
                        selectionMode="multiple"
                        headerStyle={{ width: "3em" }}
                      />
                      <Column
                        field="first_name"
                        header="First Name"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="middle_name"
                        header="Middle Name"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="last_name"
                        header="Last Name"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="job_title"
                        header="Job Title"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      /> 
                       <Column
                        field="email"
                        header="Email"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="mobile_phone"
                        header="Mobile Phone"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                       <Column
                        field="current_company"
                        header="Current Company"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      /> 
                      <Column
                        field="total_experience"
                        header="Total Experience"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                       <Column
                        field="city_name"
                        header="City"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="relocation"
                        header="Relocation"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                       <Column
                        field="categories"
                        header="Categories"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="groups"
                        header="Groups"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="primary_skills"
                        header="Primary Skills"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="created_at"
                        header="Created At"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="created_by_name"
                        header="Created By"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />
                      <Column
                        field="resume"
                        header="Resume Attachment"
                        sortable
                        filter
                        style={{ minWidth: "12rem" }}
                      />

                      
                    </DataTable>
                  </div>
                </section>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SearchResults;